<template>
  <section id="hero-imge">
      <img
        :src="$t('Header.DtpBannerImg')"
        class="d-none d-md-block img-fluid w-100"
        alt="$t('Header.HeroImageAlt')"
      />
      <img
        :src="$t('Header.MobBannerImg')"
        class="d-md-none d-block img-fluid w-100"
        alt="$t('Header.HeroImageAlt')"
      />
  </section>  
</template>

<script>

</script>

<style scoped>

</style>
